<style lang="less" scoped>
.report-table {
  height: 650px;
  font-family: verdana, arial, sans-serif;
  font-size: 16px;
  color: #333333;
  border-width: 1px;
  border-color: #efefef;
  border-collapse: collapse;
}
.report-table td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #efefef;
  text-align: center;
  color: #8f9bb3;
}
.table-title {
  width: 20%;
  color: #8f9bb3;
  background: rgba(250, 250, 250, 1);
}
.btn-table-title {
  font-family: verdana, arial, sans-serif;
  font-size: 16px;
  color: #8f9bb3;
  margin-bottom: 20px;
  text-align: center;
}
.detail-btn {
  height: 32px;
  margin-left: 200px;
}
</style>

<template>
  <div class="detail-container">
    <div class="detail-bread-crumb-div">
      <ZD-bread-crumb
        :bConfigList="pageConfig.detailBreadCrumb"
      ></ZD-bread-crumb>
    </div>
    <div class="detail-content-div">
      <div class="detail-content-header-div flex">
        <div class="left-page-title-div flex-1">报表详情</div>
      </div>
      <div class="detail-content-body-div flex-1">
        <table class="report-table" width="100%">
          <tr>
            <td colspan="4">电桩报表</td>
          </tr>
          <tr>
            <td class="table-title">IMEI号</td>
            <td>{{ detailForm.pileCode }}</td>
            <td class="table-title">所属经销商</td>
            <td>{{ detailForm.dealName }}</td>
          </tr>
          <tr>
            <td class="table-title">所属充电站点</td>
            <td>{{ detailForm.stationName }}</td>
            <td class="table-title">充电桩型号</td>
            <td>{{ detailForm.pileTypeCode }}</td>
          </tr>
          <tr>
            <td class="table-title">充电桩类型</td>
            <td>{{ detailForm.optTypeName }}</td>
            <td class="table-title">桩来源</td>
            <td>{{ detailForm.pileSourceName }}</td>
          </tr>
          <tr>
            <td class="table-title">输出类型</td>
            <td>{{ detailForm.currentOutTypeName }}</td>
            <td class="table-title">充电类型</td>
            <td>{{ detailForm.chargingSpeedName }}</td>
          </tr>
          <tr>
            <td class="table-title">1号枪头充电状态</td>
            <td>
              <span v-if="pileGunNum > 0">
                {{ detailForm.pileStatusList[0].pileStatusDetailName }}
              </span>
              <span v-else>无</span>
            </td>
            <td class="table-title">2号枪头充电状态</td>
            <td>
              <span v-if="pileGunNum > 1">
                {{ detailForm.pileStatusList[1].pileStatusDetailName }}
              </span>
              <span v-else>无</span>
            </td>
          </tr>
          <!-- <tr>
                                    <td class="table-title">3号枪头充电状态</td>
                                    <td>
                                        <span v-if="pileGunNum>2">
                                            {{detailForm.pileStatusList[2].pileStatusDetailName}}
                                        </span>
                                        <span v-else>无</span>
                                    </td>
                                    <td class="table-title">4号枪头充电状态</td>
                                    <td>
                                        <span v-if="pileGunNum>3">
                                            {{detailForm.pileStatusList[3].pileStatusDetailName}}
                                        </span>
                                        <span v-else>无</span>
                                    </td>
                                </tr> -->
          <tr>
            <td class="table-title">功率</td>
            <td>{{ detailForm.ratedPower }}</td>
            <td class="table-title">软件版本号</td>
            <td>{{ detailForm.softVersion }}</td>
          </tr>
          <tr>
            <td class="table-title">产品编号</td>
            <td>{{ detailForm.productNo }}</td>
            <td class="table-title">物联卡号</td>
            <td>{{ detailForm.iotCardNo }}</td>
          </tr>
          <tr>
            <td class="table-title">备注</td>
            <td colspan="3">
              <div class="flex">
                <div class="" v-if="remarkShow">{{ detailForm.remark }}</div>
                <el-input
                  v-if="remarkInputShow"
                  style="width:400px;"
                  size="small"
                  v-model="detailForm.remark"
                ></el-input>
                <el-button
                  v-if="remarkBtnShow"
                  type="primary"
                  size="small"
                  class="detail-btn"
                  @click="openRemarkInput"
                  >点击编辑</el-button
                >
                <el-button
                  v-if="remarkEditShow"
                  type="primary"
                  size="small"
                  class="detail-btn"
                  @click="toRemark()"
                  >编辑</el-button
                >
              </div>
            </td>
          </tr>
          <tr>
            <td class="table-title">车位号及其具体位置</td>
            <td colspan="3">
              <div class="flex">
                <div v-if="locationShow">{{ detailForm.noAndLocation }}</div>
                <el-input
                  v-if="inputShow"
                  style="width:400px;"
                  size="small"
                  v-model="detailForm.noAndLocation"
                ></el-input>
                <el-button
                  v-if="btnShow"
                  type="primary"
                  size="small"
                  class="detail-btn"
                  @click="openInput"
                  >点击编辑</el-button
                >
                <el-button
                  v-if="editShow"
                  type="primary"
                  size="small"
                  class="detail-btn"
                  @click="toEdit()"
                  >编辑</el-button
                >
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="4">运营概览</td>
          </tr>
          <tr>
            <td class="table-title">订单数量</td>
            <td>{{ detailForm.orderNum }}</td>
            <td class="table-title">用户数量</td>
            <td>{{ detailForm.custNum }}</td>
          </tr>
          <tr>
            <td class="table-title">合计充电费用</td>
            <td>{{ detailForm.feeSum }}</td>
            <td class="table-title">合计充电量kW·h</td>
            <td>{{ detailForm.chargeSum }}</td>
          </tr>
        </table>
      </div>
      <div>
        <div class="btn-table-title">用户反馈</div>
        <el-table
          :data="tableData"
          :stripe="true"
          ref="listTableRef"
          border
          class="list-table"
        >
          <el-table-column
            prop="createdWhen"
            label="报修日期"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="createdByName"
            label="报修用户"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="usingProblem"
            label="选中的问题"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="feedback"
            label="用户描述"
            min-width="150"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="remark"
            label="备注"
            min-width="150"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig,
      pagination: pageConfig.pagination,
      // 默认值设置
      detailForm: {},
      pileGunNum: '', //判断是否有充电枪
      pileStatusEntity: {}, //未使用
      tableData: [], //	用户反馈表格
      remarkShow: true, //	判断是否有备注信息
      inputShow: false, //	判断车位号输入框
      btnShow: true, //	车位号输入框编辑按钮
      editShow: false, //	车位号输入框保存
      remarkInputShow: false, //备注信息输入框
      remarkBtnShow: true, //	备注信息输入框编辑
      remarkEditShow: false, //	备注信息输入框保存
      locationShow: true, //车位号内容是否显示
    }
  },
  methods: {
    init() {
      this.getFormInfo()
    },
    // 获取表单信息
    getFormInfo() {
      let _ = this
      var obj = {
        id: _.$store.state.editId,
      }
      _.$H.post(_, _.$A.pile.findById, obj).then((res) => {
        _.detailForm = res.data.data
        //  _.pileStatusEntity = _.detailForm.pileStatusList[0];
        _.pileGunNum = _.detailForm.pileStatusList.length
        if (res.data.data.piletypeEntity) {
          _.detailForm.currentOutTypeName =
            res.data.data.piletypeEntity.currentOutTypeName
          _.detailForm.chargingSpeedName =
            res.data.data.piletypeEntity.chargingSpeedName
        }
      })
      _.$H
        .get(_, _.$A.pile.findByNo, {
          pileNo: _.$store.state.pileNo,
        })
        .then((res) => {
          _.tableData = res.data.data
        })
    },
    //点击备注编辑
    openRemarkInput() {
      this.remarkBtnShow = false
      this.remarkEditShow = true
      this.remarkShow = false
      this.remarkInputShow = true
      //this.detailForm.remark = '';
    },
    //点击保存
    toRemark() {
      let _ = this
      _.$U.showLoading(_)
      var obj = {}
      obj.id = _.$store.state.editId
      obj.remark = _.detailForm.remark
      obj.noAndLocation = _.detailForm.noAndLocation
      _.$H.post(_, _.$A.pile.updatePileDetail, obj).then((res) => {
        _.$U.success('编辑成功')
        _.remarkBtnShow = true
        _.remarkEditShow = false
        _.remarkShow = true
        _.remarkInputShow = false
        _.getFormInfo()
        _.$U.hideLoading(_)
      })
    },
    //点击车位号编辑
    openInput() {
      this.btnShow = false
      this.editShow = true
      this.locationShow = false
      this.inputShow = true
      //this.detailForm.noAndLocation = '';
    },
    //车位号保存
    toEdit() {
      let _ = this
      _.$U.showLoading(_)
      var obj = {}
      obj.id = _.$store.state.editId
      obj.remark = _.detailForm.remark
      obj.noAndLocation = _.detailForm.noAndLocation
      _.$H.post(_, _.$A.pile.updatePileDetail, obj).then((res) => {
        _.$U.success('编辑成功')
        _.btnShow = true
        _.editShow = false
        _.locationShow = true
        _.inputShow = false
        _.getFormInfo()
        _.$U.hideLoading(_)
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
